import { OrderOverviewRes } from 'services/api/dashboard';
import { sortByDate } from '../../utils';

export default function convertData(input: OrderOverviewRes): Dashboard.OrderOverviewInner {
  const {
    orderOutline,
    orderProfit,
    makingOrderData,
    chargebackInfo,
    reorderInfo,
    silenceOrderData,
    payOrderData,
  } = input;
  return {
    /** total */
    订单总量: orderOutline?.orderCount,
    订单总额: orderOutline?.orderAmount?.currencyToAmount,
    付款订单量: orderOutline?.paidCount,
    退单总量: orderOutline?.cancelOrReturnCount,
    复购订单总量: orderOutline?.reorderCount,
    非COD每日盈利: sortByDate(orderProfit?.noCodOrderProfits)?.map((item) => {
      const { date, orderCount, cancelCount, returnCount } = item;
      return {
        date,
        非COD付款订单总量: orderCount,
        非COD取消订单量: cancelCount,
        非COD退货退款量: returnCount,
      };
    }),
    COD每日盈利: sortByDate(orderProfit?.codOrderProfits)?.map((item) => {
      const { date, returnCount, orderCount, rejectCount, cancelCount } = item;
      return {
        date,
        COD退货退款量: returnCount,
        COD付款订单总量: orderCount,
        COD拒收量: rejectCount,
        COD取消订单量: cancelCount,
      };
    }),
    /** COD，非COD下单情况 */
    COD非COD下单总量: makingOrderData?.orderCount,
    COD非COD下单总金额: makingOrderData?.orderMakingAmount?.currencyToAmount,
    COD下单量: makingOrderData?.codMakingCount,
    非COD下单量: makingOrderData?.noCodMakingCount,
    'COD/非COD每日下单': sortByDate(makingOrderData?.makingOrderDataOfDays)?.map((item) => {
      const { date, makingOrderDataInfo } = item;
      return {
        date,
        COD下单总金额: makingOrderDataInfo?.codMakingOrderAmount?.currencyToAmount,
        非COD下单总金额: makingOrderDataInfo?.noCodMakingOrderAmount?.currencyToAmount,
        COD下单量: makingOrderDataInfo?.codMakingCount,
        非COD下单量: makingOrderDataInfo?.noCodMakingCount,
      };
    }),
    /** COD，非COD付款情况 */
    COD非COD付款订单总量: payOrderData?.orderCount,
    COD非COD付款总金额: payOrderData?.paidOrderAmount?.currencyToAmount,
    COD付款单量: payOrderData?.paidOrderCodCount,
    非COD付款单量: payOrderData?.paidOrderNoCodCount,
    'COD/非COD每日付款': sortByDate(payOrderData?.orderPaidDataOfDays)?.map((item) => {
      const { date, orderPayDate } = item;
      return {
        date,
        COD付款单量: orderPayDate?.codPayCount,
        非COD付款单量: orderPayDate?.noCodPayCount,
        COD付款总金额: orderPayDate?.codPayAmount?.currencyToAmount,
        非COD付款总金额: orderPayDate?.noCodPayAmount?.currencyToAmount,
      };
    }),
    静默非静默下单总量: silenceOrderData?.orderCount,
    静默非静默单下单总金额: silenceOrderData?.orderAmount?.currencyToAmount,
    静默单下单量: silenceOrderData?.silenceOrderCount,
    非静默单下单量: silenceOrderData?.noSilenceOrderCount,
    静默非静默单每日: sortByDate(silenceOrderData?.silenceOrderDataOfDays)?.map((item) => {
      const {
        date,
        orderCountSilence,
        orderNotSilenceAmount,
        orderCountNotSilence,
        orderSilenceAmount,
      } = item;
      return {
        date,
        静默单下单量: orderCountSilence,
        非静默单下单量: orderCountNotSilence,
        静默单下单总金额: orderSilenceAmount?.currencyToAmount,
        非静默单下单总金额: orderNotSilenceAmount?.currencyToAmount,
      };
    }),
    每日退单: sortByDate(chargebackInfo?.chargebackDataOfDays)?.map((item) => {
      const { date, cancelCount, returnCount } = item;
      return {
        date,
        取消订单: cancelCount,
        '退货/退款量': returnCount,
      };
    }),
    每日复购: sortByDate(reorderInfo?.reorderDataOfDays)?.map((item) => {
      const { date, orderCount, reorderCount, reorderRate } = item;
      return {
        date,
        下单总量: orderCount,
        复购单量: reorderCount,
        复购率订单占比: reorderRate,
      };
    }),
  };
}
